<template>
    <router-link v-if="showButton" :to="{name: 'lessons.show', params }" style="text-decoration: none !important;">
        <slot />
    </router-link>
    <span v-else />
</template>
<script>
    export default {
        name: 'LessonNavigationButton',

        props: {
            course: {
                required: true,
            },
            module: {
                required: true,
            },
            lesson: {
                required: true,
            },
            direction: {
                type: String,
                required: true,
            },
        },
        
        computed: {
            getLessonSlugs() {
                const summary = this.course;
                const lessonModuleId = this.module?.id;
                const lessonId = this.lesson?.id;

                if (!summary || !lessonModuleId || !lessonId) {
                    return { previous: null, next: null };
                }

                const lessonIndexInModule = this.module?.lessons.findIndex((lesson) => lesson.id === lessonId);
                const moduleIndex = summary.modules.findIndex((module) => module.id === lessonModuleId);
                const isLastLessonInModule = lessonIndexInModule === this.module?.lessons.length - 1;
                const isFirstLessonInModule = lessonIndexInModule === 0;
                const isLastModule = moduleIndex === summary.modules.length - 1;
                const isFirstModule = moduleIndex === 0;
                let previous = null;
                let next = null;

                if (!isFirstLessonInModule) {
                    previous = {
                        module: this.module,
                        lesson: this.module?.lessons[lessonIndexInModule - 1],
                    };
                } else if (!isFirstModule) {
                    previous = {
                        module: summary.modules[moduleIndex - 1],
                        lesson: summary.modules[moduleIndex - 1].lessons[summary.modules[moduleIndex - 1].lessons.length - 1],
                    };
                }

                if (!isLastLessonInModule) {
                    next = {
                        module: this.module,
                        lesson: this.module?.lessons[lessonIndexInModule + 1],
                    };
                } else if (!isLastModule) {
                    next = {
                        module: summary.modules[moduleIndex + 1],
                        lesson: summary.modules[moduleIndex + 1].lessons[0],
                    };
                }

                return { previous, next };
            },

            hideNextStep() {
                return (
                    !this.$user &&
                    (this.getLessonSlugs.next?.lesson.content_kind === "quiz" ||
                        !this.getLessonSlugs.next?.lesson.availability.available)
                );
            },

            hidePreviousStep() {
                return (
                    !this.$user &&
                    (this.getLessonSlugs.previous?.lesson.content_kind === "quiz" ||
                        !this.getLessonSlugs.previous?.lesson.availability.available)
                );
            },

            showPrevButton() {
                if (!this.hidePreviousStep) {
                    return (
                        this.direction === "previous" &&
                        this.getLessonSlugs.previous?.lesson &&
                        this.getLessonSlugs.previous.lesson.availability.available
                    );
                }
                return false;
            },

            showNextButton() {
                if (!this.hideNextStep) {
                    return (
                        this.direction === "next" &&
                        this.getLessonSlugs.next?.lesson &&
                        this.getLessonSlugs.next.lesson.availability.available
                    );
                }
                return false;
            },

            params() {
                if (this.direction === "previous") {
                    return {
                        course_slug: this.$route.params.course_slug,
                        module_slug: this.getLessonSlugs.previous?.module.slug,
                        lesson_slug: this.getLessonSlugs.previous?.lesson.slug,
                    };
                } else {
                    return {
                        course_slug: this.$route.params.course_slug,
                        module_slug: this.getLessonSlugs.next?.module.slug,
                        lesson_slug: this.getLessonSlugs.next?.lesson.slug,
                    };
                }
            },
            
            showButton() {
                return this.showPrevButton || this.showNextButton;
            },
        },
    };
</script>

<style lang="scss" scoped>
    span {
        visibility: hidden;
    }
</style>
